import { RequestAccessButton } from './RequestAccessButton';

export function LandingHero() {
  return (
    <section className="wf-hero" id="top">
      <div className="wf-hero__copy">
        <h1>
          Distribution reporting that
          <br className="wf-desktop-break" /> settles in the open.
        </h1>
        <p className="wf-hero__intro">
          Waterfall extracts contract terms, tracks license windows, calculates multi-party
          cascades, and produces statements that withstand a counterparty&apos;s second opinion. For
          the teams still defending spreadsheets at month-end close.
        </p>
        <div className="wf-hero__actions">
          <RequestAccessButton size="lg" />
        </div>
      </div>
      <div
        className="wf-illustration"
        aria-label="Illustrative waterfall, net receipts $1,847,236.42"
      >
        <div>
          <span>Net Receipts</span>
          <strong>$1,847,236.42</strong>
          <small>Illustrative waterfall</small>
        </div>
        <div className="wf-waterfall-bars" aria-hidden="true">
          {[100, 83, 65, 48, 30].map((width, index) => (
            <span key={width} style={{ width: `${width}%`, opacity: 1 - index * 0.16 }} />
          ))}
        </div>
      </div>
    </section>
  );
}
